// ---------------------------------------------- modules import
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FirebaseReducer, isEmpty, isLoaded } from "react-redux-firebase";

import { AppState } from "../../store/rootReducer";
import { IUserData } from "../../store/firebase/common";

// ---------------------------------------------- custom hooks
export const useLayout = () => {
  // ---------------------------------------------- redux connect
  const auth = useSelector(
    (state: AppState) =>
      (state.firebase as FirebaseReducer.Reducer<
        Record<string, Record<string | number, string | number>>,
        IUserData
      >).auth
  );
  const profile = useSelector(
    (state: AppState) =>
      (state.firebase as FirebaseReducer.Reducer<
        Record<string, Record<string | number, string | number>>,
        IUserData
      >).profile
  );

  // ---------------------------------------------- local state
  const [areLoaded, setAreLoaded] = useState(
    isLoaded(auth) && isLoaded(profile)
  );
  const [isEmptied, setIsEmptied] = useState(isEmpty(auth) || isEmpty(profile));

  // ---------------------------------------------- effects
  useEffect(() => {
    setAreLoaded(isLoaded(auth) && isLoaded(profile));
    setIsEmptied(isEmpty(auth) || isEmpty(profile));
  }, [auth, profile]);

  // ---------------------------------------------- return value
  return {
    profile,
    areLoaded,
    isEmptied
  };
};
